'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddressStaticPresetation = undefined;

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _pickBy = require('lodash/pickBy');

var _pickBy2 = _interopRequireDefault(_pickBy);

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _injectL10n = require('../shared/injectL10n');

var _injectL10n2 = _interopRequireDefault(_injectL10n);

var _types = require('./types');

var _types2 = require('../shared/types');

var _utils = require('../shared/utils');

var _addressFormat = require('./config/addressFormat.json');

var _addressFormat2 = _interopRequireDefault(_addressFormat);

var _utils2 = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_TEMPLET = '{address.line1}\n{address.line2}\n{address.city}, {address.stateProvince}\n{address.postalCode}\n{address.country}';

function localizeCountry(countryCode, l10n) {
  var key = 'country.displayName.' + countryCode;
  var message = l10n.formatMessage(key);
  return message === key ? countryCode : message;
}

function parseAddress(address) {
  return (0, _extends3.default)({}, address, {
    stateProvince: address.stateProvince === address.country ? null : address.stateProvince
  });
}

function localizeAddress(address, l10n) {
  return (0, _extends3.default)({}, address, {
    country: localizeCountry(address.country, l10n)
  });
}

function formatAddress(format, address) {
  return format.split('\n').map(function (fields) {
    return fields.split(',').map(function (field) {
      return (0, _utils.interpolate)(field, { address: address });
    }).filter(function (field) {
      return !!field.trim();
    }).join(',').trim();
  }).filter(function (field) {
    return field;
  });
}

var AddressStaticPresetation = function AddressStaticPresetation(_ref) {
  var l10n = _ref.l10n,
      wrap = _ref.wrap,
      nowrap = _ref.nowrap,
      countriesFormatConfig = _ref.countriesFormatConfig,
      rest = (0, _objectWithoutProperties3.default)(_ref, ['l10n', 'wrap', 'nowrap', 'countriesFormatConfig']);

  var _reduceFields = (0, _utils2.reduceFields)(rest.address),
      _reduceFields$values = _reduceFields.values,
      address = _reduceFields$values === undefined ? {} : _reduceFields$values;

  var parsedAddress = parseAddress(address);
  var config = (0, _extends3.default)({}, _addressFormat2.default, countriesFormatConfig);
  var template = config[parsedAddress.country] || DEFAULT_TEMPLET;
  var wrapped = wrap && !nowrap;
  var El = wrapped ? 'div' : 'span';
  var fields = [];

  if (!(0, _isEmpty2.default)((0, _pickBy2.default)(parsedAddress, function (a) {
    return !(0, _isEmpty2.default)(a && a.trim());
  }))) {
    fields = formatAddress(template, localizeAddress(parsedAddress, l10n));
  }

  return _react2.default.createElement(
    El,
    null,
    fields.map(function (f, i) {
      return _react2.default.createElement(
        El,
        { key: f },
        f,
        !wrapped && i < fields.length - 1 ? ', ' : ''
      );
    })
  );
};

exports.AddressStaticPresetation = AddressStaticPresetation;
AddressStaticPresetation.propTypes = {
  address: _types.addressPropTypes,
  wrap: _propTypes.bool,
  nowrap: _propTypes.bool,
  l10n: _types2.aauiL10nShape,
  countriesFormatConfig: _propTypes.object // eslint-disable-line
};

AddressStaticPresetation.defaultProps = {
  wrap: true,
  nowrap: false,
  countriesFormatConfig: {}
};

exports.default = (0, _injectL10n2.default)()(AddressStaticPresetation);